import { useEffect, useState, useContext } from "react";
import { differenceInCalendarDays, parseISO, format, isSameDay, addDays } from "date-fns";
import IndividualStaff from "./individalstaff";
import ViewAppraisal from "./viewappraisals";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../AuthContext";

import DisciplinaryForm from "./discipinaryform";
import CreateAppraisal from "./createapraisal";
import { ArrowDownIcon } from "@heroicons/react/20/solid";

const parseCalendarDate = (value) => {
  if (!value) return null;
  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }

  if (typeof value === 'string') {
    const parsedIso = parseISO(value);
    if (!Number.isNaN(parsedIso.getTime())) return parsedIso;
  }

  const fallback = new Date(value);
  return Number.isNaN(fallback.getTime()) ? null : fallback;
};

export default function StaffDetails() {
  const [staffSummary, setStaffSummary] = useState([]);
  const [policies, setPolicies] = useState(null);
  const [staffIndividualName, setStaffIndividualName] = useState(null); // Renamed to avoid conflict
  const [staffIndividualNow, setStaffIndividualNow] = useState(null);
  const [staffIndividualDocs, setStaffIndividualDocs] = useState(null);
  const [staffDocuments, setStaffDocuments] = useState(null);
  const [edit, setEdit] = useState(null);
  const [issue, setIssue] = useState(false);

  const navigate = useNavigate();

  const user =  useContext(AuthContext);

  console.log(user); // Debugging output

  console.log(staffIndividualNow); // Debugging output

  console.log(staffIndividualName); // Debugging output

  useEffect(() => { 
    const getDisciplinary = async () => {
      const response = await fetch("https://api.insightos.co.uk/api/alldisciplinary", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
        credentials : 'include',


      });

      if (!response.ok) {
        console.error("Failed to fetch data");
        return;
      }

      const { data: disciplinary } = await response.json();

      console.log(disciplinary);

      // Check if the staff individual is selected and fetch the data
      
    }

    getDisciplinary();


  }, []); // This runs when `staffIndividualName` changes
    

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch("https://api.insightos.co.uk/api/staffpolicy", {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
          credentials : 'include',

        });

        const { success, clockins, holiday, staff, data: policies, shifts } =
          await response.json();

        if (!success) {
          console.error("Failed to fetch data");
          return;
        }

        console.log(staff); // Debugging output

        setPolicies(policies[0]); // Assuming there's only one set of policies

        // Process each staff member
        const summary = staff.map((staffMember) => {
          const staffId = staffMember.id;

          // Calculate sick days and sick occasions

          // turn c.Sick into a INTEGER 0 or 1

          // Assuming clockins is an array of objects with a Sick property


          const sickDates = shifts
            .filter((c) => c.StaffId === staffId && // the Sick === 1 needs to be an integer 0 or 1
              c.Sick === 1) // Assuming there's a `Sick` field in `shifts`
            .map((c) => parseISO(c.ShiftDate)); // Assuming there's a `Date` field in `clockins`


          let sickOccasions = 0;
          if (sickDates.length > 0) {
            sickDates.sort((a, b) => a - b); // Sort dates
            sickOccasions = 1; // At least one sick occasion if there are sick days

            for (let i = 1; i < sickDates.length; i++) {
              const prevDate = sickDates[i - 1];
              const currentDate = sickDates[i];

              // If the current date is not consecutive to the previous date, increment the occasion count
              if (!isSameDay(currentDate, addDays(prevDate, 1))) {
                sickOccasions++;
              }
            }
          }

          const sickDays = sickDates.length;

          console.log(sickDays); // Debugging output

          // Calculate late occasions
          const lateOccasions = clockins.filter(
            (c) => c.StaffId === staffId && c.Late === 1
          ).length;


        // calculate salary for staff member

       

         const averageHours = staffMember.AverageHours || 0;
         const averageDays = staffMember.AverageDays || 0;


        const hourlyRate = staffMember.HourlyRate;
        const contractHours = staffMember.ContractedHours; // Hours per week
        const contractDays = staffMember.ContractedDays; // Days per week
        
        // Use AverageHours and AverageDays if ContractType is "0 Hours", otherwise use ContractedHours and ContractedDays
        const hoursToUse = staffMember.ContractType === '0 Hours' ? averageHours : contractHours;
        const daysToUse = staffMember.ContractType === '0 Hours' ? averageDays : contractDays;
        
        // Yearly salary
        const yearlySalary = hourlyRate * hoursToUse * 52; 
        
        // Monthly salary
        const monthlySalary = yearlySalary / 12; 
        
        // Weekly salary
        const weeklySalary = hourlyRate * hoursToUse; 
        





          
          // Calculate holidays booked
          const holidaysForStaff = staffMember.HolidayTaken

          const holidayDays = holidaysForStaff;

          const holidayAllowance = staffMember.HolidayEntitlement;


// get the OpenDays from the policies 

const Role = staffMember.Role;


          // Extract and format Last Appraisal
          const lastAppraisal = staffMember.LastAppraisal
            ? format(parseISO(staffMember.LastAppraisal), "dd/MM/yyyy")
            : "No Data";

          // Convert Probation status
          const probationStatus = staffMember.Probation
            ? format(parseISO(staffMember.Probation), "dd/MM/yyyy")
            : "No Data";

          const leavingDateParsed = parseCalendarDate(staffMember.LeavingDate);
          const leavingDateDisplay = leavingDateParsed ? format(leavingDateParsed, "dd/MM/yyyy") : null;
          const isLeavingToday = leavingDateParsed ? isSameDay(leavingDateParsed, new Date()) : false;
          const isLeaving = Boolean(leavingDateParsed);

          const onMaternity = staffMember.Maternity === 1;

          return {
            Name: staffMember.Name,
            SickDays: sickDays,
            Role : Role,
            SickOccasions: sickOccasions,
            LateOccasions: lateOccasions,
            HolidayDays: holidayDays,
            HolidayAllowance : holidayAllowance,
            LastAppraisal: lastAppraisal,
            ProbationStatus: probationStatus,
            id: staffMember.id,
            YearlySalary: yearlySalary,
            MonthlySalary: monthlySalary,
            WeeklySalary: weeklySalary,
            HourlyRate: hourlyRate,
            ContractedHours: contractHours,
            EffectiveHours: hoursToUse, // Hours actually used in calculations
            ContractedDays: contractDays,
            EffectiveDays: daysToUse, // Days actually used in calculations
            ContractType: staffMember.ContractType,
            OnMaternity: onMaternity,
            LeavingDate: leavingDateDisplay,
            IsLeaving: isLeaving,
            IsLeavingToday: isLeavingToday,
          };
        });

        setStaffSummary(summary);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []); // Runs once when component mounts


  console.log(staffSummary); // Debugging output

  useEffect(() => {
    const getStaff = async () => {

      const token = localStorage.getItem('token');

      const response = await fetch("https://api.insightos.co.uk/api/staff", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
        credentials : 'include',

      });

      if (!response.ok) {
        console.error("Failed to fetch data");
        return;
      }

      const { data: staff } = await response.json();

      // Check if the staff individual is selected and fetch the data
      const selectedStaff = staff.find((staffMember) => staffMember.Name === staffIndividualName);

      console.log(selectedStaff);

      if (selectedStaff) {
        setStaffIndividualNow(selectedStaff);
      } else {
        console.error("Staff not found");
      }
    };

    if (staffIndividualName) {
      getStaff();
    }

  }, [staffIndividualName]); // This runs when `staffIndividualName` changes

  console.log(staffIndividualDocs); // Debugging output
    
  useEffect(() => {
    const getStaff = async () => {

      const token = localStorage.getItem('token');

      const response = await fetch("https://api.insightos.co.uk/api/staff", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
        credentials : 'include',

      });

      if (!response.ok) {
        console.error("Failed to fetch data");
        return;
      }

      const { data: staff } = await response.json();

      console.log(staff);

      // Check if the staff individual is selected and fetch the data
      const selectedStaff = staff.find((staffMember) => staffMember.Name === staffIndividualDocs);

      console.log(selectedStaff);


      if (selectedStaff) {
        setStaffDocuments(selectedStaff);
      } else {
        console.error("Staff not found");
      }
    };

    if (staffIndividualDocs) {
      getStaff();
    }

  }, [staffIndividualDocs]); 


  
  if (edit) {
    navigate( "/viewappraisal", { state: { id: edit } });
    
  }




  // Render IndividualStaff component if data is available
  if (staffIndividualNow) {
    return <IndividualStaff staff={staffIndividualNow} />;
  }

  console.log(staffDocuments); // Debugging output

  if (staffIndividualDocs) {

    // staffdocuments is an object i just need the id


    return <ViewAppraisal id={staffDocuments} />;
  }

  console.log(staffSummary); // Debugging output

  return (
    <div className="px-4 sm:px-6 lg:px-8">
      <div className="sm:flex sm:items-center">
        <div className="sm:flex-auto">
          <h1 className="text-base font-semibold text-gray-900">Staff Summary</h1>
          <p className="mt-2 text-sm text-gray-700">
            View details for all staff, including their adherence to company policies.
          </p>
        </div>
      </div>
      <div className="mt-8 flow-root">
        <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
            <table className="min-w-full divide-y divide-gray-300">
              <thead>
                <tr>
                  <th className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-0">
                    Name
                  </th>
                  <th className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                    Role
                  </th>
                  <th className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                    Sick Days
                  </th>
                  <th className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                    Sick Occasions
                  </th>
                  <th className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                    Late Occasions
                  </th>
                  <th className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                    Holiday Hours
                  </th>
                  <th className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                    Hourly Rate
                  </th>
                   <th className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                    Contract Type
                  </th>
                  <th className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                    Effective Hours
                  </th>
                  <th className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                    Effective Days
                  </th>

                  <th className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                    Weekly Salary
                  </th>
                  <th className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                    Monthly Salary
                  </th>
                  <th className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                    Yearly Salary
                  </th>


                  <th className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                    Last Appraisal
                  </th>
                  <th className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                    Leaving Date
                  </th>
                  <th className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                    Probation Status
                  </th>
                  <th className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
                {staffSummary.map((staff, index) => (
                  <tr key={index}>
                    <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium sm:pl-0">
                      <div className="flex flex-col">
                        <span className={staff.IsLeaving || staff.OnMaternity ? "text-red-500" : "text-gray-900"}>
                          {staff.Name}
                        </span>
                        {staff.IsLeaving && (
                          <span className="mt-1 text-xs font-semibold uppercase tracking-wide text-red-500">
                            Leaving staff member
                          </span>
                        )}
                        {staff.OnMaternity && (
                          <span className="mt-1 text-xs font-semibold uppercase tracking-wide text-red-500">
                            On maternity leave
                          </span>
                        )}
                      </div>
                    </td>
                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                      <span className={staff.IsLeaving ? "text-red-500" : "text-gray-500"}>{staff.Role}</span>
                    </td>

                    {/* Sick Days */}
                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                      <div className="flex items-center">
                        <span className={`mr-2 ${staff.IsLeaving ? "text-red-500" : "text-gray-500"}`}>{staff.SickDays}</span>
                        {user.access === "admin" || user.access === "manager" && ( 
                        <button
                          onClick={() => navigate('/backtoworkdashboard')}
                          data-component="staff-details"
                          data-feature="view-sickness-details"
                          className="rounded bg-indigo-600 px-2 py-1 text-xs font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                        >
                          View Details
                        </button>
                        )}
                        <div className="w-full bg-gray-200 rounded-full h-2.5 mr-3">
                          <div
                            className={`h-2.5 rounded-full ${
                              staff.SickDays > policies.SickDays
                                ? "bg-red-600"
                                : "bg-green-500"
                            }`}
                            style={{
                              width: `${(staff.SickDays / policies.SickDays) * 100}%`,
                            }}
                          />
                        </div>
                        {staff.SickDays > policies.SickDays && (
                          <button
                            onClick={() => navigate('/appraisals')}
                            data-component="staff-details"
                            data-feature="raise-sickness-issue"
                            className="rounded bg-red-600 px-2 py-1 text-xs font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                          >
                            Raise Issue
                          </button>
                        )}
                      </div>
                    </td>

                    {/* Sick Occasions */}
                    <td className="whitespace-nowrap px-3 py-4 text-sm">
                      <span className={staff.IsLeaving ? "text-red-500" : "text-black"}>{staff.SickOccasions}</span>
                    </td>

                    {/* Late Occasions */}
                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                      <div className="flex items-center">
                        <span className={`mr-2 text-bold ${staff.IsLeaving ? "text-red-500" : "text-black"}`}>{staff.LateOccasions}</span>
                        <div className="w-full bg-gray-200 rounded-full h-2.5 mr-3">
                          <div
                            className={`h-2.5 rounded-full ${
                              staff.LateOccasions > policies.LateOccasions
                                ? "bg-red-600"
                                : "bg-green-500"
                            }`}
                            style={{
                              width: `${(staff.LateOccasions / policies.LateOccasions) * 100}%`,
                            }}
                          />
                        </div>
                        {staff.LateOccasions > policies.LateOccasions && (
                          <button
                            onClick={() => navigate('/appraisals')}
                            data-component="staff-details"
                            data-time-saved="2"
                            data-feature="raise-lateness-issue"
                            className="rounded bg-red-600 px-2 py-1 text-xs font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                          >
                            Raise Issue
                          </button>
                        )}
                      </div>
                    </td>

                    {/* Holiday Days */}
                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                      <span className={staff.IsLeaving ? "text-red-500" : "text-gray-500"}>{staff.HolidayDays} / {staff.HolidayAllowance}</span>
                    </td>
                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                      <span className={staff.IsLeaving ? "text-red-500" : "text-gray-500"}>£{staff.HourlyRate}</span>
                    </td>
                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                      <span className={staff.IsLeaving ? "text-red-500" : "text-gray-500"}>{staff.ContractType}</span>
                    </td>
                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                      <span className={staff.IsLeaving ? "text-red-500" : "text-gray-500"}>{staff.ContractedHours}</span>
                    </td>
                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                      <span className={staff.IsLeaving ? "text-red-500" : "text-gray-500"}>{staff.EffectiveDays}</span>
                    </td>
                    

                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
  <span className={staff.IsLeaving ? "text-red-500" : "text-gray-500"}>£{staff.WeeklySalary.toFixed(2)}</span>
</td>
<td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
  <span className={staff.IsLeaving ? "text-red-500" : "text-gray-500"}>£{staff.MonthlySalary.toFixed(2)}</span>
</td>
<td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
  <span className={staff.IsLeaving ? "text-red-500" : "text-gray-500"}>£{staff.YearlySalary.toFixed(2)}</span>
</td>

                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                      <span className={staff.IsLeaving ? "text-red-500" : "text-gray-500"}>{staff.LastAppraisal}</span>
                    </td>
                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                      <div className="flex items-center gap-2">
                        <span className={staff.IsLeaving ? "text-red-500" : "text-gray-500"}>{staff.LeavingDate || '—'}</span>
                        {staff.IsLeavingToday && (
                          <button
                            onClick={() => navigate('/users')}
                            className="rounded bg-red-600 px-2 py-1 text-xs font-semibold text-white shadow-sm hover:bg-red-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-600"
                          >
                            Go to Users
                          </button>
                        )}
                      </div>
                    </td>
                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                      <span className={staff.IsLeaving ? "text-red-500" : "text-gray-500"}>{staff.ProbationStatus}</span>
                    </td>
                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                    <div className="relative">
  <select
    defaultValue=""
    onChange={(e) => {
      const action = e.target.value;
      console.log(action); // Debugging output
      if (action === "details") setStaffIndividualName(staff.Name);
      if (action === "docs") setStaffIndividualDocs(staff.Name);
      if (action === "edit") setEdit(staff.id);
      // Reset select to default after action
      e.target.value = "";
    }}
    data-component="staff-details"
    data-feature="staff-action-select"
    className="rounded bg-indigo-600 px-2 py-1 text-xs font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
  >
    <option value="" disabled>Select Action</option>
    <option value="details">View Individual Details</option>
    <option value="docs">View Appraisals</option>
    <option value="edit">Edit Appraisal</option>
  </select>
</div>

                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}
